import dayjs from 'dayjs'

type setTimeType = {
  days: string
  hours: string
  minutes: string
  seconds: string
}

type startTimerType = {
  countDownDate: string
  setTime: ({ days, hours, minutes, seconds }: setTimeType) => void
  callback?: () => void
}

export const startTimer = ({ countDownDate, setTime, callback }: startTimerType) => {
  const dateEnd = dayjs(countDownDate)
  let currentDate = dayjs()

  if (currentDate.diff(dateEnd) >= 0 && callback) {
    callback()
  }

  const daysDifference = Math.trunc(dateEnd.diff(currentDate, 'day'))

  currentDate = currentDate.add(daysDifference, 'day')

  const hoursDifference = Math.trunc(dateEnd.diff(currentDate, 'hour', true))

  currentDate = currentDate.add(hoursDifference, 'hours')

  const minutesDifference = Math.trunc(dateEnd.diff(currentDate, 'minutes'))

  currentDate = currentDate.add(minutesDifference, 'minutes')

  const secondDifference = Math.trunc(dateEnd.diff(currentDate, 'seconds'))

  setTime({
    days: `${daysDifference}`,
    hours: hoursDifference < 10 ? `0${hoursDifference}` : `${hoursDifference}`,
    minutes: minutesDifference < 10 ? `0${minutesDifference}` : `${minutesDifference}`,
    seconds: secondDifference < 10 ? `0${secondDifference}` : `${secondDifference}`,
  })
}
